import request from "./request";
import apis from "./apis";

const {
  subjectInfo,
} = apis.subject;

const student = {
  getSubjects: () => {
    return request.get(subjectInfo);
  },
  createSubject: (data: Object) => {
    return request.post(subjectInfo, data);
  },
  updateSubject: (data: Object) => {
    return request.put(subjectInfo, data);
  },
  deleteSubject: (data: Object) => {
    return request.delete(subjectInfo, data);
  },
};

export default student;